// extracted by mini-css-extract-plugin
export default {"clearPage_wrapper":"FAQ_clearPage_wrapper__r5DZv","helpPage_wrapper":"FAQ_helpPage_wrapper__jKlBk","pullToRefresh":"FAQ_pullToRefresh__F3069"};